import { Injectable, NgZone, inject, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private zone = inject(NgZone);
  private count = 0;

  readonly loading = signal(false);

  show(): void {
    this.zone.run(() => {
      //this.count++;
      this.loading.set(true);
    });
  }

  hide(): void {
    this.zone.run(() => {
      // if (this.count > 0) {
      //   this.count--;
      // }

      //if (this.count === 0) {
        this.loading.set(false);
      //}
    });
  }

  reset(): void {
    this.zone.run(() => {
      this.count = 0;
      this.loading.set(false);
    });
  }
}